import { render, staticRenderFns } from "./featureTwo.vue?vue&type=template&id=34f85e1a&"
import script from "./featureTwo.vue?vue&type=script&lang=js&"
export * from "./featureTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports